import {
  Button,
  Form,
  Input,
  Segmented,
  Select,
  Tag,
  message,
  Spin,
} from "antd";
import React, { useState } from "react";
import {
  PlusCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import EditableTable from "../../Reusable/Table/EditableTable";
import ReusableDrawer from "../../Reusable/Drawer/Drawer";
import { LoadingOutlined } from "@ant-design/icons";
import Loadingpage from "../Loadingpage/Loadingpage";
const CreateOwnAssets = () => {
  const [page, setPage] = useState({ current: 1, pageSize: 10 });
  const [totalPage, setTotalPage] = useState(3);
  const [search, setSearch] = useState("");
  const [confirmLoading, setConfirmLoading] = useState(false);
const [loading, setLoading] = useState(false);
  const [assets, setAssets] = useState([
    {
      key: 1,
      sno: 1,
      assetname: "Bitcoin",
      Network_symbol: "BTC",
      Network_name: "Bitcoin Network",
      type: "Crypto",
      status: 1,
    },
    {
      key: 2,
      sno: 2,
      assetname: "Ethereum",
      Network_symbol: "ETH",
      Network_name: "Ethereum Mainnet",
      type: "Crypto",
      status: 1,
    },
    {
      key: 3,
      sno: 3,
      assetname: "USDT",
      Network_symbol: "USDT",
      Network_name: "Tether Network",
      type: "Stablecoin",
      status: 0,
    },
  ]);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState(null);
  const [status, setStatus] = useState(1);
  const [formLayout] = useState("vertical");
  const { Search } = Input;
  const [form] = Form.useForm();




  const assetsColumns = [
    { title: "Sno", dataIndex: "sno", key: "sno" },
    { title: "Asset Name", dataIndex: "assetname", key: "assetname" },
    {
      title: "Network Symbol",
      dataIndex: "Network_symbol",
      key: "Network_symbol",
    },
    { title: "Network Name", dataIndex: "Network_name", key: "Network_name" },
    { title: "Type", dataIndex: "type", key: "type" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) => {
        return value === 1 ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">In-Active</Tag>
        );
      },
    },

    {
      title: "Action",
      key: "select",
      // fixed: "right",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEditAsset(record)}
        >
          Edit
        </Button>
      ),
    },
  ];

  const handlePagination = (pagination) => setPage(pagination);

  const onClose = () => {
    setOpenDrawer(false);
    setSelectedAssets(null);
    form.resetFields();
  };

const handleCreateAssets = () => {
  setLoading(true); 

  setTimeout(() => {
    form.resetFields();
    setSelectedAssets(null);
    setStatus(1);
    setOpenDrawer(true);

    setLoading(false); 
  }, 2000);
};

  const handleEditAsset = (record) => {
    setSelectedAssets(record);
    setStatus(record.status === 1 ? 1 : 0);
    setOpenDrawer(true);
    form.setFieldsValue(record);
  };

const onFinish = (values) => {
  setLoading(true); 

  setTimeout(() => {
    if (selectedAssets) {
      const updatedAssets = assets.map((item) =>
        item.key === selectedAssets.key ? { ...item, ...values, status } : item,
      );

      setAssets(updatedAssets);
      message.success("Asset updated successfully!");
    } else {
      const newAsset = {
        key: assets.length + 1,
        sno: assets.length + 1,
        ...values,
        status,
      };

      setAssets([...assets, newAsset]);
      message.success("New asset created successfully!");
    }

    onClose();
    setLoading(false); 
  }, 2000);
};
  return (
    <>
    <Loadingpage/>
      <div className="display-2 p-10">
        <h2>Create Own Assets</h2>
        <div className="display-1" style={{ display: "flex", gap: 10 }}>
          <Search
            placeholder="Search for name"
            onSearch={(value) => setSearch(value)}
            allowClear
            style={{ width: 200 }}
            loading={confirmLoading}
            // className="input-cls"
          />
          <Button
            type="primary"
            iconPosition="start"
            icon={<PlusCircleOutlined />}
            onClick={handleCreateAssets}
            loading={loading}
          >
            Create
          </Button>
        </div>
      </div>

      <EditableTable
        columnsConfig={assetsColumns}
        dataSource={assets}
        total={assets.length}
        pageSize={page?.pageSize || 10}
        current={page?.current || 1}
        closeDisabled={true}
        onChange={handlePagination}
      />

      <ReusableDrawer
        open={openDrawer}
        onClose={onClose}
        title={selectedAssets ? "Edit Asset" : "Create Asset"}
        extra={<CloseCircleOutlined className="cursor" onClick={onClose} />}
      >
        <Form
          layout={formLayout}
          form={form}
          onFinish={onFinish}
          style={{ maxWidth: 600 }}
        >
          <Form.Item
            label="Asset Name"
            name="assetname"
            rules={[{ required: true, message: "Please enter asset name" }]}
          >
            <Input placeholder="Enter Asset name" />
          </Form.Item>

          <Form.Item
            label="Network Symbol"
            name="Network_symbol"
            rules={[{ required: true, message: "Please enter network symbol" }]}
          >
            <Input placeholder="Enter Network Symbol" />
          </Form.Item>

          <Form.Item
            label="Network Name"
            name="Network_name"
            rules={[{ required: true, message: "Please enter network name" }]}
          >
            <Input placeholder="Enter Network Name" />
          </Form.Item>

          <Form.Item
            label="Type"
            name="type"
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select placeholder="Select type">
              <Select.Option value="Crypto">Crypto</Select.Option>
              <Select.Option value="Stablecoin">Stablecoin</Select.Option>
              <Select.Option value="Token">Token</Select.Option>
              <Select.Option value="NFT">NFT</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item name="status" label="Status">
            <Segmented
              options={[
                { label: "Active", value: 1 },
                { label: "In-Active", value: 0 },
              ]}
              value={status}
              onChange={(value) => setStatus(value)}
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              disabled={loading}
            >
              {selectedAssets ? "Save Changes" : "Create Asset"}
            </Button>
          </Form.Item>
        </Form>
      </ReusableDrawer>
    </>
  );
};

export default CreateOwnAssets;
